import "./global.css";
import "./theme/theme.css";
import "./locales/i18n";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router";
import App from "./App";
import menuService from "./api/services/menuService";
import { registerLocalIcons } from "./components/icon";
import { GLOBAL_CONFIG } from "./global-config";
import ErrorBoundary from "./routes/components/error-boundary";
import { routesSection } from "./routes/sections";
import { urlJoin } from "./utils";

await registerLocalIcons();

// Handle chunk loading errors globally
if (typeof window !== "undefined") {
	window.addEventListener("error", (event) => {
		if (
			event.error?.message?.includes("Failed to fetch dynamically imported module") ||
			event.error?.message?.includes("Loading chunk")
		) {
			console.warn("Chunk loading error detected, will retry on next navigation");
			// Clear the failed chunk from cache
			if ("caches" in window) {
				caches.keys().then((names) => {
					names.forEach((name) => {
						if (name.includes("vite") || name.includes("chunk")) {
							caches.delete(name);
						}
					});
				});
			}
		}
	});

	window.addEventListener("unhandledrejection", (event) => {
		if (
			event.reason?.message?.includes("Failed to fetch dynamically imported module") ||
			event.reason?.message?.includes("Loading chunk")
		) {
			console.warn("Chunk loading error in promise rejection, will retry on next navigation");
			event.preventDefault(); // Prevent default error handling
			// Clear the failed chunk from cache
			if ("caches" in window) {
				caches.keys().then((names) => {
					names.forEach((name) => {
						if (name.includes("vite") || name.includes("chunk")) {
							caches.delete(name);
						}
					});
				});
			}
		}
	});
}

// Start MSW worker only in development and only if enabled
// Set VITE_ENABLE_MSW=true in .env to enable MSW
const enableMSW = import.meta.env.VITE_ENABLE_MSW === "true" && import.meta.env.DEV;

if (enableMSW) {
	try {
		// Dinamikus import: statikusan behúzva az MSW és az ÖSSZES mock-kezelő
		// a belépő kötegbe kerülne, és éles buildbe is bekerülne — hiába nem
		// indul el soha. A futásidejű feltétel a fordítóra nincs hatással.
		const { worker } = await import("./_mock");

		await worker.start({
			onUnhandledRequest: "bypass",
			serviceWorker: {
				url: urlJoin(GLOBAL_CONFIG.publicPath, "mockServiceWorker.js"),
				options: {
					scope: GLOBAL_CONFIG.publicPath,
				},
			},
		});
	} catch (error) {
		console.warn("Failed to start MSW worker:", error);
		// Continue without MSW if it fails
	}
}
if (GLOBAL_CONFIG.routerMode === "backend") {
	await menuService.getMenuList();
}

const router = createBrowserRouter(
	[
		{
			Component: () => (
				<App>
					<Outlet />
				</App>
			),
			errorElement: <ErrorBoundary />,
			children: routesSection,
		},
	],
	{
		basename: GLOBAL_CONFIG.publicPath,
	},
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<RouterProvider router={router} />);
